// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GDunJzzgFqQY_3 {
  flex-shrink: 0;
  margin: 0;
  transition: 0.1s ease;
}
.SoJoBusTiv7mde {
  padding-left: 8px;
}
.board-wrapper.is-show-menu .GDunJzzgFqQY_3 {
  display: none;
}
.wlPspAT3kPhOGv {
  margin: 0 4px 0 0;
}
.GnlSVSm1AD0_i9 {
  margin-top: -44px;
}
@media print {
  .GnlSVSm1AD0_i9 {
    display: none;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"showSidebarButton": `GDunJzzgFqQY_3`,
	"showSidebarButtonWithText": `SoJoBusTiv7mde`,
	"sidebarExtraMargin": `wlPspAT3kPhOGv`,
	"popover": `GnlSVSm1AD0_i9`
};
export default ___CSS_LOADER_EXPORT___;
